import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useFetch } from '../hooks/useApiCall';
import { getMyAppointments } from '../services/appointmentService';
import { PmLoading, PmError, PmEmpty } from '../components/pm/PmStates';
import { IconCalendar, IconClock, IconList, IconArrow } from '../components/pm/PmIcons';
import { BUSINESS, ROUTES } from '../data/pmContent';

export const STATUS = {
  pending: 'Pendiente',
  confirmed: 'Confirmada',
  completed: 'Completada',
  cancelled: 'Cancelada',
  no_show: 'No asistió',
};

export const StatusChip = ({ status }) => (
  <span className={`chip chip--${STATUS[status] ? status : 'soft'}`}>{STATUS[status] || status}</span>
);

export const formatDate = (iso, opts = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }) =>
  iso ? new Date(iso).toLocaleDateString('es-DO', opts) : '-';

export const formatTime = (iso) =>
  iso ? new Date(iso).toLocaleTimeString('es-DO', { hour: '2-digit', minute: '2-digit' }) : '-';

const MyAppointments = () => {
  const { data: appointments, loading, error, refetch } = useFetch(getMyAppointments);

  return (
    <div className="pm-scope account">
      <Helmet>
        <title>Mis citas - {BUSINESS.name}</title>
      </Helmet>

      <section className="section">
        <div className="container container--narrow">
          <header className="account__head">
            <div>
              <span className="eyebrow">Tu cuenta</span>
              <h1>Mis citas</h1>
              <p>Consulta el estado de tus reservas y el detalle de cada servicio.</p>
            </div>
            <Link to={ROUTES.agendar} className="btn btn--primary">
              Agendar nueva cita <IconArrow />
            </Link>
          </header>

          {loading && <PmLoading message="Cargando tus citas…" />}
          {error && <PmError message={error} onRetry={refetch} />}

          {!loading && !error && appointments && appointments.length === 0 && (
            <PmEmpty
              title="Todavía no tienes citas"
              text="Agenda tu primera cita con nosotras: eliges servicio, día y hora en menos de 2 minutos."
              action={<Link to={ROUTES.agendar} className="btn btn--primary">Agendar cita</Link>}
            />
          )}

          {appointments && appointments.length > 0 && (
            <div className="acct-grid">
              {appointments.map((appointment) => {
                // Support both plural (new) and singular (legacy)
                const services = appointment.services || (appointment.service ? [appointment.service] : []);
                const mainLabel = services.length > 1
                  ? `${services[0]?.name} +${services.length - 1} más`
                  : (services[0]?.name || 'Cita');

                return (
                  <article className="acct-card acct-card--hover" key={appointment.id}>
                    <div className="acct-card__top">
                      <h2>{mainLabel}</h2>
                      <StatusChip status={appointment.status} />
                    </div>
                    <ul className="acct-card__meta">
                      <li><IconCalendar /> {formatDate(appointment.scheduled_at)}</li>
                      <li><IconClock /> {formatTime(appointment.scheduled_at)}</li>
                      {services.length > 0 && (
                        <li><IconList /> {services.length} servicio{services.length > 1 ? 's' : ''}</li>
                      )}
                    </ul>
                    <div className="acct-card__foot">
                      <Link to={`/mis-citas/${appointment.id}`} className="btn btn--secondary btn--sm">
                        Ver detalle
                      </Link>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default MyAppointments;
